import resourcesManager from './resources/resourcesManager';
import snowflakeTestConnectionManager from './snowflakeTestConnection/snowflakeTestConnectionManager';
import snowflakeGetQueryManager from './snowflakeGetQuery/snowflakeGetQueryManager';
import snowflakePushDataToAzureManager from './snowflakePushDataToAzure/snowFlakePushDataToAzureManager';
import snowflakeDataPushStatusManager from './snowflakedataPushStatus/snowflakeDataPushStatusManager';
import usersManager from './users/usersManager';
import authManager from './auth/authManager';
import healthManager from './health/healthManager';
import uploadManager from './upload/uploadManager';
import uploadStatusManager from './uploadStatus/uploadStatusManager';
import uploadModelStatusManager from './uploadModelStatus/uploadModelStatusManager';
import downloadManager from './download/downloadManager';
import deleteManager from './delete/deleteManager';
import summaryManager from './summary/summaryManager';
import datasourceColumnsManager from './datasourceColumns/datasourceColumnsManager';
import datasourceUsersManager from './datasourceUsers/datasourceUsersManager';
import modelTrainManager from './modelTrain/modelTrainManager';
import modelAddingManager from './modelAdding/modelAddingManager';
import modelAddingStatusManager from './modelAddingStatus/modelAddingStatusManager';
import trainStatusManager from './trainStatus/trainStatusManager';
import trainProgressManager from './trainProgress/trainProgressManager';
import uploadProgressManager from './uploadProgress/uploadProgressManager';
import snowflakePushDataProgressManager from './snowflakePushDataProgress/snowflakePushDataProgressManager';
import userModelsManager from './userModels/userModelsManager';
import predictionManager from './prediction/predictionManager';
import predictionProgressManager from './predictionProgress/predictionProgressManager';
import predictionStatusManager from './predictionStatus/predictionStatusManager';
import modelListManager from './modelList/modelListManager';
import modelViewManager from './modelView/modelViewManager';
import modelSettingsManager from './modelSettings/modelSettingsManager';
import modelSummaryManager from './modelSummary/modelSummaryManager';
import modelVisualisationsManager from './modelVisualisations/modelVisualisationsManger';
import modelSummaryArraysManager from './modelSummaryArrays/modelSummaryArraysManager';
import modelSummarySaveManager from './modelSummarySave/modelSummarySaveManager';
import previewManager from './preview/previewManager';
import storageManager from './storage/storageManager';
import actionsPreviewManager from './actionsPreview/actionsPreviewManager';
import previewStatusManager from './previewStatus/previewStatusSaveManager';
import deployManager from './deploy/deployManager';
import undeployManager from './undeploy/undeployManager';
import deployStatusManager from './deployStatus/deployStatusManager';
import viewUrlManager from './viewUrl/viewUrlManager';
import uploadModelManager from './upladModel/uploadModelManager';
import dataProcessingManager from './dataProcessing/dataProcessingManager';
import dataProcessingMergeManager from './dataProcessingMerge/dataProcessingMergeManager';
import dataProcessingGroupByManager from './dataProcessingGroupBy/dataProcessingGroupByManager';
import dataProcessingGroupByProgressManager from './dataProcessingGroupByProgress/dataProcessingGroupByProgressManager';
import previewsMergeManager from './previewsMerge/previewsMergeManager';
import dataProcessingStatusManager from './dataProcessingStatus/dataProcessingStatusManager';
import dataProcessingMergeStatusManager from './dataProcessingMergeStatus/dataProcessingMergeStatusManager';
import dataProcessingGroupByStatusManager from './dataProcessingGroupByStatus/dataProcessingGroupByStatusManager';
import dataProcessingProgressManager from './dataProcessingProgress/dataProcessingProgressManager';
import dataProcessingMergeProgressManager from './dataProcessingMergeProgress/dataProcessingMergeProgressManager';
import uploadDatasetManager from './uploadDataset/uploadDatasetManager';
import taskStoppageManager from './taskStoppage/taskStoppageManager';

const API = {
  auth: authManager,
  health: healthManager,
  users: usersManager,
  resources: resourcesManager,
  snowflakeTestConnection: snowflakeTestConnectionManager,
  snowflakeGetQuery: snowflakeGetQueryManager,
  snowflakePushDataToAzure: snowflakePushDataToAzureManager,
  snowflakeDataPushStatus: snowflakeDataPushStatusManager,
  upload: uploadManager,
  modelAdding: modelAddingManager,
  uploadStatus: uploadStatusManager,
  uploadModelStatus: uploadModelStatusManager,
  modelAddingStatus: modelAddingStatusManager,
  download: downloadManager,
  delete: deleteManager,
  taskStoppage: taskStoppageManager,
  summary: summaryManager,
  datasourceColumns: datasourceColumnsManager,
  datasourceUsers: datasourceUsersManager,
  modelTrain: modelTrainManager,
  trainStatus: trainStatusManager,
  trainProgress: trainProgressManager,
  uploadProgress: uploadProgressManager,
  snowflakePushDataProgress: snowflakePushDataProgressManager,
  userModels: userModelsManager,
  prediction: predictionManager,
  predictionProgress: predictionProgressManager,
  predictionStatus: predictionStatusManager,
  modelList: modelListManager,
  modelView: modelViewManager,
  modelSettings: modelSettingsManager,
  modelSummary: modelSummaryManager,
  modelVisualisations: modelVisualisationsManager,
  modelSummaryArrays: modelSummaryArraysManager,
  modelSummarySave: modelSummarySaveManager,
  preview: previewManager,
  storage: storageManager,
  actionsPreview: actionsPreviewManager,
  previewStatus: previewStatusManager,
  deploy: deployManager,
  undeploy: undeployManager,
  deployStatus: deployStatusManager,
  viewUrl: viewUrlManager,
  uploadModel: uploadModelManager,
  dataProcessing: dataProcessingManager,
  dataProcessingMerge: dataProcessingMergeManager,
  dataProcessingGroupBy: dataProcessingGroupByManager,
  dataProcessingGroupByProgress: dataProcessingGroupByProgressManager,
  previewsMerge: previewsMergeManager,
  dataProcessingStatus: dataProcessingStatusManager,
  dataProcessingMergeStatus: dataProcessingMergeStatusManager,
  dataProcessingGroupByStatus: dataProcessingGroupByStatusManager,
  dataProcessingProgress: dataProcessingProgressManager,
  dataProcessingMergeProgress: dataProcessingMergeProgressManager,
  uploadDataset: uploadDatasetManager
};

export default API;
// ddd
